let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZetx"), load("34i4a"), load("cGSfe"), load("8E4u5"), load("6wr18"), load("ffEVr"), load("irgIM")]).then(() => parcelRequire('cbZqw'));